import i18next from "i18next";

/**
 * Engelska ligger på egna /en-URL:er med en separat i18next-instans. Moduler
 * utanför React-trädet (prisformat, kategorinamn) kan inte läsa den instansen,
 * så rotlayouten registrerar här om aktuell sida är engelsk.
 */
let englishRouteMode = false;

export function setEnglishRouteMode(value: boolean) {
  englishRouteMode = value;
}

export function isEnglishActive(): boolean {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    if (path === "/en" || path.startsWith("/en/")) return true;
  }
  if (englishRouteMode) return true;
  return (i18next.language || "sv").toLowerCase().startsWith("en");
}
